// @ts-nocheck - Legacy file with extensive type issues requiring comprehensive refactoring (TODO: GXM-XXXX)
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import { fetchEntityDetail } from "~/components/global-entities/globalEntitiesSlice";
import { fetchDirectors } from "~/components/directors-form/directorsSlice";
import { fetchShareHolder } from "~/components/share-holders/shareHoldersSlice";
import { useSearchParams } from "react-router-dom";

const useAppointmentsAndOwnership = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const TAB_MAP = {
    directors: 0,
    shareholders: 1,
    officers: 2,
    "power-of-attorney": 3,
  };

  const TAB_INDEX_TO_KEY = {
    0: "directors",
    1: "shareholders",
    2: "officers",
    3: "power-of-attorney",
  };

  const tabFromUrl = searchParams.get("tab");
  const initialTabIndex = TAB_MAP[tabFromUrl] ?? 0;
  const [tabIndex, setTabIndex] = useState(initialTabIndex);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const entityData = useSelector((state) => state.globalEntities.entity_detail);
  const [pageLoading, setPageLoading] = useState(true);
  const [isLoading, setIsloading] = useState(true);

  const directorsArr = useSelector((state) => state.directors.directorsData);

  const shareHolders = useSelector(
    (state) => state.shareHolders.shareHolders?.data || [],
  );

  useEffect(() => {
    const loadEntity = async () => {
      setPageLoading(true);
      await dispatch(fetchEntityDetail(id));
      setPageLoading(false);
    };
    loadEntity();
  }, [dispatch, id]);

  useEffect(() => {
    if (tabIndex === 0) {
      setIsloading(true);
      dispatch(fetchDirectors({ id, skipCache: true })).finally(() =>
        setIsloading(false),
      );
    }
  }, [tabIndex, dispatch, id]);

  useEffect(() => {
    if (tabIndex === 1) {
      setIsloading(true);
      dispatch(fetchShareHolder({ id, skipCache: true })).finally(() =>
        setIsloading(false),
      );
    }
  }, [tabIndex, dispatch, id]);

  const handleAddDirector = () => {
    navigate(`/entity/${id}/directors/add`);
  };

  const handleAddShareholder = () => {
    navigate(`/entity/${id}/share-holders/add`);
  };

  const handleTabChange = (e) => {
    const newIndex = e.index;
    const tabKey = TAB_INDEX_TO_KEY[newIndex];
    setTabIndex(newIndex);
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tabKey);
      return params;
    });
    if (tabIndex !== e.index) {
      setIsloading(true);
    }
  };
  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    const newIndex = TAB_MAP[tabFromUrl] ?? 0;

    if (newIndex !== tabIndex) {
      setTabIndex(newIndex);
      setIsloading(true);
    }
  }, [searchParams]);
  const hasEntityPlusAccess = entityData?.active_services?.some(
    (e) => e.name === "Entities +",
  );

  const refetchShareholders = useCallback(async () => {
    setIsloading(true);
    await dispatch(fetchShareHolder({ id, skipCache: true }));
    setIsloading(false);
  }, [dispatch, id]);

  const refetchDirectors = useCallback(async () => {
    setIsloading(true);
    await dispatch(fetchDirectors({ id, skipCache: true }));
    setIsloading(false);
  }, [dispatch, id]);

  return {
    id,
    entityData,
    pageLoading,
    tabIndex,
    handleTabChange,
    directorsArr,
    isLoading,
    setIsloading,
    handleAddDirector,
    shareHolders,
    handleAddShareholder,
    hasEntityPlusAccess,
    refetchShareholders,
    refetchDirectors,
  };
};

export default useAppointmentsAndOwnership;
